var auth = require('./auth-handler');
var authHandler = auth.authHandler;

var swal = require('bootstrap-sweetalert');
swal.setDefaults({ animation: false });

var constants = require('./constants');
var awsConstants = constants.awsConstants;
var availableLocales = constants.serverConstants.availableLocales;
var filekeyHelpers = require('./filekey-helpers');
var checksumHelpers = require('./checksum-helpers');
var computeHash = checksumHelpers.computeHash;
var generateChecksumErrorMessage = checksumHelpers.generateChecksumErrorMessage;
var groupBy = require('./group-by');

var uploadResource2FormModel = {
    init: function () {
        this.availableLocales = availableLocales;
        this.latestResource2List = [];
        this.onResource2List();
        this.isProcessing = false;
    },
    onResource2List: function (isUpdate) {
        var self = this;
        var resource2List = this.getResource2List();
        var resource2ByLocale = groupBy(resource2List, 'locale');
        var existingLocales = Object.keys(resource2ByLocale);
        var latestResource2List = [];
        existingLocales.forEach(function (locale) {
            var latestLocaleFileObj = resource2ByLocale[locale].sort(function (a, b) {
                return new Date(b.date) - new Date(a.date);
            })[0];
            latestResource2List.push({
                locale: locale,
                key: latestLocaleFileObj.key,
                username: latestLocaleFileObj.username,
                date: latestLocaleFileObj.date,
                version: latestLocaleFileObj.version
            });
        });
        self.latestResource2List = latestResource2List;
        this.resource2LocaleListIsNewState = {};
        this.availableLocales.forEach(function (locale) {
            if (existingLocales.indexOf(locale) === -1) {
                self.resource2LocaleListIsNewState[locale] = true;
            } else {
                self.resource2LocaleListIsNewState[locale] = false;
            }
        });
        self.latestResource2List = latestResource2List;
        if (isUpdate) {
            uploadResource2FormView.renderLocalesList();
        }
    },
    getResource2List: function () {
        return JSON.parse(localStorage.getItem('resource2-list'));
    },
    updateResource2List: function (list) {
        localStorage.setItem('resource2-list', JSON.stringify(list));
    },
    getUsername: function () {
        return localStorage.getItem('username');
    },
    getAvailableLocales: function () {
        return this.availableLocales;
    },
    getLatestResource2List: function () {
        return this.latestResource2List;
    },
    getResource2LocaleListIsNewState: function () {
        return this.resource2LocaleListIsNewState;
    },
    setResource2LocaleListIsNewState: function (locale, isNew) {
        this.resource2LocaleListIsNewState[locale] = isNew;
    }
};

var uploadResource2FormController = {
    init: function () {
        uploadResource2FormModel.init();
        uploadResource2FormView.init();
    },
    validateResource2Inputs: function (resource2Inputs) {
        var resource2Errors = [];
        var self = this;
        resource2Inputs.forEach(function (obj) {
            if (!obj.file) {
                resource2Errors.push('File missing for ' + obj.locale);
            }
            if (!obj.checksum) {
                resource2Errors.push('Checksum missing for ' + obj.locale);
            }
            if (!obj.version) {
                resource2Errors.push('Version missing for ' + obj.locale);
            } else if (!self.checkVersionFormat(obj.version)) {
                resource2Errors.push('Invalid version format for ' + obj.locale + '. The correct version format is x.x.x.');
            }
        });
        return resource2Errors;
    },
    validateResource2Checksums: function (resource2Inputs) {
        var resource2HashPromises = [];
        var resource2NameToFileArray = [];

        resource2Inputs.forEach(function (localeObj) {
            resource2NameToFileArray.push({
                name: localeObj.locale,
                file: localeObj.file,
                checksum: localeObj.checksum
            });
        });

        resource2NameToFileArray.forEach(function (obj) {
            resource2HashPromises.push(computeHash(obj.file));
        });

        return Promise.all(resource2HashPromises).then(function (hashes) {
            var checksumErrorMessages = [];
            hashes.forEach(function (hash, index) {
                var fileObj = resource2NameToFileArray[index];
                if (fileObj.checksum !== hash) {
                    checksumErrorMessages.push(generateChecksumErrorMessage(hash, fileObj.checksum, fileObj.locale));
                }
            });
            return checksumErrorMessages;
        });
    },
    handleSubmit: function (resource2Inputs) {
        var self = this;
        if (uploadResource2FormModel.isProcessing) return; // Avoid submits when in progress
        uploadResource2FormModel.isProcessing = true;
        uploadResource2FormView.toggleSpinnerState('show');
        var errorMessages = this.validateResource2Inputs(resource2Inputs);
        if (errorMessages.length) {
            uploadResource2FormModel.isProcessing = false;
            uploadResource2FormView.toggleSpinnerState('hide');
            swal('Validation Errors', errorMessages.join('\n'), 'error');
            return;
        }

        this.validateResource2Checksums(resource2Inputs)
            .then(function (checksumErrorMessages) {
                if (checksumErrorMessages.length) {
                    uploadResource2FormModel.isProcessing = false;
                    uploadResource2FormView.toggleSpinnerState('hide');
                    swal('Validation Errors', checksumErrorMessages.join('\n'), 'error');
                    throw new Error('checksumsInconsistent');
                }
                var refreshTokenIfNeededPromise;
                if (window.session.isValid()) {
                    refreshTokenIfNeededPromise = Promise.resolve(null);
                } else {
                    refreshTokenIfNeededPromise = authHandler.init();
                }
                return refreshTokenIfNeededPromise;
            })
            .then(function () {
                return self.uploadResource2FilesS3(resource2Inputs);
            })
            .then(function (result) {
                uploadResource2FormModel.isProcessing = false;
                uploadResource2FormView.toggleSpinnerState('hide');
                swal('Successful Upload', 'Resource 2 Files successfully uploaded', 'success');
                var resource2List = uploadResource2FormModel.getResource2List();
                resource2Inputs.forEach(function (o) {
                    resource2List.push(o);
                });
                uploadResource2FormModel.updateResource2List(resource2List);
                uploadResource2FormModel.onResource2List(true);
            })
            .catch(function (error) {
                uploadResource2FormModel.isProcessing = false;
                if (error.message === 'checksumsInconsistent' || error === 'cancelled' || error === 'authexpired') { return; }
                swal('Firmware Upload Error', error, 'error');
                uploadResource2FormModel.toggleSpinnerState('hide');
            });
    },
    uploadResource2FilesS3: function (resource2Inputs) {
        var fileUploadPromises = [];

        resource2Inputs.forEach(function (obj) {
            var fileKey = filekeyHelpers.generateResourceFile2Key(obj.locale, obj.checksum, obj.version);
            var uploadFileParams = {
                Bucket: awsConstants.buckets.std,
                Key: fileKey,
                ContentType: obj.file.type,
                Body: obj.file,
                Metadata: {
                    locale: obj.locale,
                    version: obj.version,
                    checksum: obj.checksum,
                    date: obj.date
                }
            };
            if (obj.username) {
                uploadFileParams.Metadata.username = obj.username;
            }
            fileUploadPromises.push(window.s3.putObject(uploadFileParams).promise());
        });
        return Promise.all(fileUploadPromises);
    },
    checkVersionFormat: function (version) {
        return /^(\d+\.)?(\d+\.)?(\*|\d+)$/.test(version);
    }
};

var uploadResource2FormView = {
    init: function () {
        this.uploadResource2FormEl = document.querySelector('#upload-resource2-form');
        this.localesListEl = document.querySelector('#locales-table');
        this.uploadResource2FilesButtonTextEl = document.querySelector('#upload-firmware-button-text');
        this.uploadResource2ButtonSpinnerEl = document.querySelector('#upload-firmware-button-spinner');
        this.initSubmitHandler();
        this.renderLocalesList();
        this.initToggleResource2LocaleStateHandlers();
        this.initLocaleFileNameHandlers();
    },
    initLocaleFileNameHandlers: function () {
        var self = this;
        var localeListState = uploadResource2FormModel.getResource2LocaleListIsNewState();
        Object.keys(localeListState).forEach(function (locale) {
            if (localeListState[locale]) {
                var localFileTd = locale + '-file-td';
                document.querySelector('#' + locale + '-file').onchange = function (e) {
                    var fileName = e.target.value.replace(/^.*\\/, '');
                    self.updateSelectedFileName(localFileTd, fileName, true);
                };
            }
        });
    },
    initToggleResource2LocaleStateHandlers: function () {
        var self = this;
        this.localesListEl.addEventListener('click', function (e) {
            var id = e.target.getAttribute('id');
            if (!id) {
                return;
            }
            if (id.indexOf('locale-toggle') !== -1) {
                var parts = id.split('-');
                var locale = parts[2];
                var stateString = parts[3];
                if (stateString === 'new') {
                    uploadResource2FormModel.setResource2LocaleListIsNewState(locale, false);
                    self.toggleLocaleFormGroup(locale, false);
                } else {
                    uploadResource2FormModel.setResource2LocaleListIsNewState(locale, true);
                    self.toggleLocaleFormGroup(locale, true);
                }
            }
        });
    },
    updateSelectedFileName: function (divId, fileName) {
        var selectedFileText = document.querySelector('#' + divId + ' .selected-file-text');
        selectedFileText.innerHTML = fileName;
        selectedFileText.style = 'margin-right:5px';
        document.querySelector('#' + divId + ' .select-file-button-text').innerHTML = 'Change File';
    },
    initSubmitHandler: function () {
        this.uploadResource2FormEl.addEventListener('submit', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var localesState = uploadResource2FormModel.getResource2LocaleListIsNewState();
            var resource2Inputs = [];
            Object.keys(localesState).forEach(function (locale) {
                var localeFileEl = document.querySelector('#' + locale + '-file');
                var localeVersionEl = document.querySelector('#' + locale + '-version');
                var localeChecksumEl = document.querySelector('#' + locale + '-checksum');
                var localeFile;
                var localeVersion;
                var localeChecksum;
                if (localeFileEl) {
                    localeFile = document.querySelector('#' + locale + '-file').files[0];
                }
                if (localeVersionEl && localeVersionEl.value) {
                    localeVersion = localeVersionEl.value.replace(/ /g, '').trim();
                }
                if (localeChecksumEl && localeChecksumEl.value) {
                    localeChecksum = localeChecksumEl.value.replace(/ /g, '').trim();
                }
                var isNew = localesState[locale];
                var localeObj = {};
                if (isNew && (localeFile || localeVersion || localeChecksum)) {
                    localeObj.locale = locale;
                    localeObj.file = localeFile;
                    localeObj.version = localeVersion;
                    localeObj.checksum = localeChecksum;
                    localeObj.date = new Date().toUTCString();
                    var username = uploadResource2FormModel.getUsername();
                    if (username) {
                        localeObj.username = uploadResource2FormModel.getUsername();
                    };
                    resource2Inputs.push(localeObj);
                };
            });

            if (!resource2Inputs.length) {
                swal('Error', 'No changes in firmware 2 files. Please update a file before submitting.', 'error');
                return;
            }
            uploadResource2FormController.handleSubmit(resource2Inputs);
        });
    },
    toggleSpinnerState: function (state) {
        if (state === 'show') {
            this.uploadResource2FilesButtonTextEl.innerHTML = 'Uploading';
            this.uploadResource2ButtonSpinnerEl.style = 'margin-right:5px;';
        } else {
            this.uploadResource2FilesButtonTextEl.innerHTML = 'Upload';
            this.uploadResource2ButtonSpinnerEl.style = 'display:none;';
        }
    },
    renderLocalesList: function () {
        var self = this;
        var localeListState = uploadResource2FormModel.getResource2LocaleListIsNewState();
        var localesWithExistingFiles = uploadResource2FormModel.getLatestResource2List().map(function (res) {
            return res.locale;
        });
        var localesHTML = [];
        Object.keys(localeListState).forEach(function (locale) {
            var isNew = localeListState[locale];
            var showExisting;
            if (localesWithExistingFiles.indexOf(locale) !== -1) {
                showExisting = true;
            }
            localesHTML.push(self.renderLocaleFormGroup(locale, isNew, showExisting));
        });
        this.localesListEl.innerHTML = localesHTML.join('\n');
    },
    toggleLocaleFormGroup: function (locale, isNew) {
        if (isNew) {
            document.querySelector('#' + locale + '-group').innerHTML = this.createNewFormGroupHTML(locale, isNew, true);
            this.initLocaleFileNameHandlers();
        } else {
            document.querySelector('#' + locale + '-group').innerHTML = this.createExistingFormGroupHTML(locale);
        }
    },
    renderLocaleFormGroup: function (locale, isNew, showExisting) {
        if (isNew) {
            return this.createNewFormGroupHTML(locale, isNew, showExisting);
        } else {
            return this.createExistingFormGroupHTML(locale);
        }
    },
    createNewFormGroupHTML: function (locale, isNew, showExisting) {
        var newHTML = [
            '<tr id="' + locale + '-group"' + '>',
            '<td style="vertical-align:middle; width:6em">' + locale + '</td>',
            '<td style="vertical-align:middle; width:30em" id="' + locale + '-file-td">',
            '<label class="btn btn-default btn-file">',
            '<span class="select-file-button-text">Select  File </span>',
            '<input type="file"  id="' + locale + '-file"',
            'name="resource-file-2" multiple="" data-min-file-count="1" style="display: none;">',
            '</label>',
            '<span class="selected-file-text"></span>',
            '</div>',
            '</td>',
            '<td style="vertical-align:middle; width:25em">',
            '<input type="text" class="form-control" placeholder="Checksum"',
            'id="' + locale + '-checksum">',
            '</td>',
            '<td style="vertical-align:middle; width:25em">',
            '<input type="text" class="form-control" placeholder="Version"',
            'id="' + locale + '-version">',
            '</td>'
        ];

        if (showExisting) {
            newHTML.push('<td  style="vertical-align:middle; width:5em; text-align:center;"><button type="button" class="btn btn-link" id="locale-toggle-' + locale + '-new">Existing</button></td>');
        } else {
            newHTML.push('<td style="width:5em"></td>');
        }
        newHTML.push('</tr>');
        return newHTML.join('\n');
    },
    createExistingFormGroupHTML: function (locale) {
        var latestResource2List = uploadResource2FormModel.getLatestResource2List();
        var obj = latestResource2List.find(function (localeObj) {
            return localeObj.locale === locale;
        });
        var existingHTML = [
            '<tr id="' + locale + '-group"' + '>',
            '<td style="vertical-align:middle; width:6em">' + locale + '</td>',
            '<td style="vertical-align:middle; width:30em">Uploaded at ' + obj.date + '</td>'
        ];
        if (obj.username) {
            var name = obj.username.charAt(0).toUpperCase() + obj.username.slice(1);
            existingHTML.push('<td style="vertical-align:middle; width:25em">Uploaded by ' + name + '</td>');
        }
        existingHTML.push('<td style="vertical-align:middle; width:25em">Version: ' + obj.version + '</td>');
        existingHTML.push('<td  style="vertical-align:middle; width:5em; text-align:center;"><button type="button" class="btn btn-link" id="locale-toggle-' + locale + '-existing">New</button></td></tr>');
        return existingHTML.join('\n');
    }

};

module.exports = { uploadResource2FormController: uploadResource2FormController };
